import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-20 px-4 py-12">
      <div className="container mx-auto max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-blue-400 hover:bg-blue-500/10"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>

        <div className="bg-white/5 backdrop-blur-lg rounded-xl p-6 md:p-8 border border-white/10">
          <h1 className="text-3xl font-bold text-white mb-6">Terms & Conditions</h1>


          <div className="space-y-8 text-gray-300">
            <section>
              <p className="mb-4">
                Welcome to White Pearl Finance ("Company", "we", "our", or "us"). By accessing or using our website whitepearlfinance.com ("Website"), you agree to comply with and be bound by these Terms & Conditions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Eligibility</h2>
              <p>By using this Website, you confirm that you are at least 18 years old and legally capable of entering into agreements.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Services</h2>
              <p>Our Website provides financial information, tools, and third-party services (including credit score checks, if applicable). We do not guarantee accuracy, completeness, or availability of services at all times.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. User Responsibilities</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>You agree to provide accurate and complete information.</li>
                <li>You agree not to use our Website for fraudulent or unlawful activities.</li>
                <li>You are responsible for maintaining the confidentiality of your login credentials (if applicable).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Intellectual Property</h2>
              <p>All content, design, text, graphics, logos, and other materials on the Website are owned by or licensed to White Pearl Finance and protected under applicable intellectual property laws.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Third-Party Services</h2>
              <p>Our Website may provide access to third-party APIs (such as CIBIL or fintech partners). We are not responsible for the availability, accuracy, or practices of these third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Limitation of Liability</h2>
              <p>We are not liable for any direct, indirect, or consequential damages arising out of your use of our Website or reliance on the information provided.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Indemnity</h2>
              <p>You agree to indemnify and hold harmless White Pearl Finance from any claims, losses, or damages arising from your misuse of the Website.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Governing Law</h2>
              <p>These Terms shall be governed by the laws of India, and disputes will be subject to the jurisdiction of the courts in Mumbai, Maharashtra.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Updates</h2>
              <p>We may update these Terms from time to time. Please check this page periodically for any changes.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
